import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Visit } from 'src/app/admin/models/visit.model';
import { VisitService } from 'src/app/admin/services/visit.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-surcharge-modal',
  templateUrl: './surcharge-modal.component.html',
  styleUrls: ['./surcharge-modal.component.scss'],
})
export class SurchargeModalComponent implements OnInit {
  visit: Visit;
  visitId: number;
  errMsg = '';
  msg = '';
  connection;
  disconnectedOnPurpose = false;
  apiUrl = environment.apiUrl;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  visits$ = this.visitService.visit$;
  Visits$: Observable<Visit[]>;
  currentPage = 1; 
  itemsPerPage = 10; 
  fullNameVisitorQuery: string = '';
  visitStatusQuery:string='';
  paginationSettings = {totalItems: 0};
  visitForm: string | any;
  visitorSelected = false;
  roomId;
  qrCode = '';
  currentTime = new Date();

  

  constructor(private modalController: ModalController, private visitService: VisitService) {}

  ngOnInit() {

  }
  loadVisit() {
    let codeToSend =this.qrCode.toString();

    this.errMsg = '';

    this.visitService.getVisitByCardId(codeToSend).subscribe(result => {
      this.visit = result as Visit;
    }, (err) => {
      this.errMsg = 'Nije moguće pronaći posetu.';
      console.error(err);
    });     
  } 


  editVisit() {
    this.visitService.editVisitSurcharge(this.visit).subscribe(res => {
       this.loadVisit();   
      this.dismissModal();
      location.href = 'admin/manage-visits';
    },(err) => {
      console.error(err);
    });
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  getCardType(cardType: number, hours: number) {
    let cardTypeName;
    let cardHours;
    if (cardType === 0) {
      cardTypeName = 'Sat';
      cardHours = hours;
    }
    else if (cardType === 1) {
      cardTypeName = 'Poludnevna karta';
    }
    else if (cardType === 2) {
      cardTypeName = 'Dnevna karta';
    }
    return { cardTypeName, cardHours };
  }

  getTimeInside() {
    console.log(this.visit);
    const enter: any = new Date(this.visit.enter);
    const now: any = new Date(new Date().toISOString().slice(0,-1));

    const diffMs = (now - enter); // milliseconds between now & Christmas
    const diffDays = Math.floor(diffMs / 86400000); // days
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    const hrs = diffDays >= 1 ? (diffDays * 24) + diffHrs : diffHrs;
    return `${hrs.toString().length === 1 ? '0' : ''}${hrs}:${diffMins.toString().length === 1 ? '0' : ''}${diffMins}`
  }



}
